import component from './components/details';

export default {
  component
};
